import React from 'react';
import UserForm from "../users/UserForm";
import RoleSelect from "../users/RoleSelect";
import {useGetDataVendorRolesQuery, useGetRolesQuery} from "../../api/roleApiSlice";

export const DataVendorUserForm = ({dataVendorId, canSelectRole, ...props}) => {
  const {data: roles = [], isSuccess} = dataVendorId ? useGetDataVendorRolesQuery(dataVendorId) : useGetRolesQuery()

  return <UserForm  {...props}>
    {canSelectRole && <RoleSelect role companyType={"data_vendor"} roles={roles}/>}
  </UserForm>
}
